import React from 'react';
const policyLinks = [{
  label: 'Shipping',
  href: 'https://blackoutunit.com/policies/shipping-policy'
}, {
  label: 'Returns',
  href: 'https://blackoutunit.com/policies/refund-policy'
}, {
  label: 'Privacy',
  href: 'https://blackoutunit.com/policies/privacy-policy'
}, {
  label: 'Terms',
  href: 'https://blackoutunit.com/policies/terms-of-service'
}];
export function SiteFooter() {
  return <footer className="border-t border-gunmetal/60 bg-carbon pb-28 pt-16 md:pb-12" data-id="element-291" data-mp="2wmhr8vg0i64g">
      <div className="mx-auto grid max-w-7xl gap-10 px-5 md:grid-cols-12 md:px-8" data-id="element-292" data-mp="2ro7wun2439jw">
        <div className="md:col-span-4" data-id="element-293" data-mp="2rm3tc684kck5">
          <p className="font-display text-3xl uppercase leading-none tracking-[0.04em] text-bone" data-id="element-294" data-mp="36bszygyzl8rt">
            Blackout Unit<span className="ml-0.5 align-top text-xs" data-id="element-295" data-mp="31f2jhsj9sb5v">™</span>
          </p>
          <p className="mt-3 max-w-xs text-sm leading-relaxed text-steel" data-id="element-296" data-mp="3fcr6p70t7ue3">
            Issue 01 // Nocturne. BU-01 // Ultimate Mask. Same world.
            Different you.
          </p>
        </div>

        <div className="text-sm md:col-span-3" data-id="element-297" data-mp="2a255m1sl8ep">
          <p className="text-[11px] font-medium uppercase tracking-[0.18em] text-steel" data-id="element-298" data-mp="2bd8jkrbse5a">
            Support
          </p>
          <ul className="mt-4 space-y-2 text-bone/85" data-id="element-299" data-mp="c7g94m6j44q4">
            <li data-id="element-300" data-mp="c5vekwk7sls9">
              <a href="mailto:support@blackoutunit.com" className="transition-colors duration-150 hover:text-white" data-id="element-301" data-mp="c9j7pulqz66g">
                support@blackoutunit.com
              </a>
            </li>
            <li data-id="element-302" data-mp="q6pnrhf36qrz">
              <a href="tel:+13055550142" className="transition-colors duration-150 hover:text-white" data-id="element-303" data-mp="q6651yhm3ycw">
                +1 (305) 555-0142
              </a>
            </li>
            <li className="text-steel" data-id="element-304" data-mp="zvpslhg9sge3">Mon–Fri, 9 AM–5 PM EST</li>
          </ul>
        </div>

        <div className="text-sm md:col-span-3" data-id="element-305" data-mp="14xf0wpc3yfyh">
          <p className="text-[11px] font-medium uppercase tracking-[0.18em] text-steel" data-id="element-306" data-mp="18xp8u7jgngfz">
            Address
          </p>
          <address className="mt-4 not-italic leading-relaxed text-bone/85" data-id="element-307" data-mp="35xtnm19ag249">
            4531 Madison Industrial Lane, Unit 4531
            <br data-id="element-308" data-mp="310jvgduilccq" />
            Tampa, FL 33605, USA
          </address>
        </div>

        <nav aria-label="Policies" className="text-sm md:col-span-2" data-id="element-309" data-mp="3erovhh1so6nl">
          <p className="text-[11px] font-medium uppercase tracking-[0.18em] text-steel" data-id="element-310" data-mp="3a06uwu3oo835">
            Policies
          </p>
          <ul className="mt-4 space-y-2 text-bone/85" data-id="element-311" data-mp="3onrx8lsqi3a0">
            {policyLinks.map(link => <li key={link.label} data-id="element-312" data-mp="3joorez4xjt0z">
                <a href={link.href} className="transition-colors duration-150 hover:text-white" data-id="element-313" data-mp="3jphy603w2ij4">
                  {link.label}
                </a>
              </li>)}
          </ul>
        </nav>
      </div>

      <div className="mx-auto mt-12 flex max-w-7xl flex-col gap-3 border-t border-gunmetal/60 px-5 pt-6 text-xs text-steel md:flex-row md:items-center md:justify-between md:px-8" data-id="element-314" data-mp="23c9nzjbylwe8">
        <p data-id="element-315" data-mp="1p5py85rglir9">© 2026 BLACKOUT UNIT™. All rights reserved.</p>
        <p data-id="element-316" data-mp="1p8c3tzusho6u">Visa · Mastercard · Amex · PayPal · Shop Pay · Apple Pay</p>
      </div>
    </footer>;
}